import { useQuery } from '@tanstack/react-query';
import type { TGetMoodBoardsResponse } from 'api/resources/moodBoards';
import { getMoodBoards } from 'api/resources/moodBoards';
import { ECacheKeys } from 'cache/CacheKeys';

export const useGetMoodBoards = (token: string) => {
	return useQuery<TGetMoodBoardsResponse>({
		queryKey: [ECacheKeys.MoodBoards],
		queryFn: () => getMoodBoards(token),
		retry: 1,
		refetchOnWindowFocus: false,
	});
};
